// components/Address/AddressField.js
import React from 'react';
import { Typography } from '@mui/material';

const AddressField = ({
  value,
  onChange,
  error,
  readOnly,
  headingColor
}) => (
  <>
    <input
      style={{
        border: '1px solid #b8bdc9',
        borderRadius: '3px',
        padding: '10px',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: 1.45,
        color: headingColor,
        marginBottom: '8px',
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
    <Typography
      variant='subtitle1'
      display={error !== '' && value !== '' ? 'block' : 'none'}
      color={'#FF0000'}
      fontWeight={700}
    >
      {error}
    </Typography>
  </>
);

export default AddressField;
